import 'helpers/sentry';
import { publish, AGENT_LOADED } from 'helpers/pubsub';
import { initializeOptimizely } from 'helpers/optimizely';
import initPublicApi from 'public-api/init';
import { initInspirationsRemoved } from 'apps/InspirationsRemoved/init';
import { initInspirationsApi } from 'apps/InspirationsApi';
import { initRemoveFromList } from 'apps/RemoveFromListModal/init';
import { initAddToList } from 'apps/AddToListModal/init';
import { allFavouritedImagesInStorage, isImageFavourited } from 'helpers/store';

export function init() {
    if (!window.ikea) {
        throw Error('Favs-Agent: window.ikea is missing');
    }
    window.ikea.favourites = {
        agentLoaded: true,
        isImageFavourited,
        allFavouritedImagesInStorage,
        addToFavourites: initAddToList(),
        removeFromFavourites: initRemoveFromList(),
        ...initInspirationsApi(),
    };

    initPublicApi();

    initializeOptimizely();
    initInspirationsRemoved();

    publish(AGENT_LOADED, null);
}
